import Paper from '@material-ui/core/Paper';
import React from "react";
import { isCounterParty } from "../Common/CheckAuthorization";
import Comingsoonpath from "../../assets/images/coming soon.jpg";
export default function AllMainFarmSelectedDialog() {
    if( isCounterParty() ){
        return <div className="coomingsoonimg"> 
        <img alt="Coming soon"  src={Comingsoonpath} />
        </div>
    }
    return (
        <Paper className="superAdminDialog">
            *Please select one of the Main Farm
        </Paper>
    )
}




// WEBPACK FOOTER //
// ./src/components/Common/AllMainFarmSelectedDialog.js